import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  staticData: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  searchProductsInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialGeneralState = {
  campaignsInsights: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialAdvertisersState = {
  advertisersList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditAdvertiser: {
    status: status.SHOULD_CALL_API,
  },
  advertiserDetails: {},
};

export const initialCampaignsState = {
  campaignsList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  campaignInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditCampaign: {
    status: status.SHOULD_CALL_API,
  },
  campaignDetails: {},
};

export const initialAdvertsState = {
  advertsList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  addOrEditAdvert: {
    status: status.SHOULD_CALL_API,
  },
};

export const initialAccountManagementState = {};
